import { getProductSelectedByDrugManufacturerId } from 'utils/productComparison/getProductSelectedByDrugManufacturerId';

export const getUnitsSelectedByDrugManufacturerId = (id: string | number, EX5937, products) => {
    const productsById = getProductSelectedByDrugManufacturerId(id, products, EX5937);
    return productsById?.reduce((acc, value) => {
        return (acc += value[id]?.quantity_suggested ?? value.quantity);
    }, 0);
};
